const brand = sessionStorage.getItem('brand');
export const home = {
  greetingText: 'Zdravo, ',
  greetingHand: '👋',
  upgrade: 'Unapredi',
  integrate: 'Integriraj',
  integrate2: 'Integriraj',
  chatGPT: 'ChatGPT ',
  forYourBusiness: 'za vašu tvrtku',
  insights: 'Uvidi',
  message: 'Poruke',
  addon: 'Dodatak: ',
  leads: 'Potencijalni kupci',
  yourBots: 'Vaši Botovi',
  botName: 'Ime Bota',
  platform: 'Platforma',
  contactOrLeads: 'Kontakti/Potencijalni kupci',
  actions: 'Akcije',
  edit: 'uredi',
  delete: 'izbriši',
  createA: 'Stvori ',
  whatsappChatbot: 'WhatsApp Chatbot ',
  connect: 'Poveži',
  getStartedWithUs: 'Počnite s nama 👏',
  howToBuildAGoodChatFlow: ' Kako izgraditi dobar chatflow',
  howToUseBotPenguinInboxAndItsFeatures: ` Kako koristiti BotPenguinov Inbox i njegove značajke`,
  botPenguinPricing: ` BotPenguinova cijena: Istraživanje planova i značajki`,
  openHelpDesk: ' Otvori pomoćni stol',
  helpAndSupport: 'Pomoć i podrška',
  extensiveGuides: 'Obimni vodiči za sva vaša pitanja i radne tokove dostupni su u našem',
  resourceCentre: 'Resource Centre.',
  checkoutOurAnswers: 'Možete provjeriti naše odgovore na uobičajena pitanja u nastavku.',
  createANewBot: 'Stvorite novog bota',
  installYourBot: 'Instalirajte svog bota',
  plansAndPricing: 'Planovi i cijene',
  searchLanguage: 'Pretraži jezik',
  whatsappConversations: 'WhatsApp razgovori',
  diveDeeperIntoBotPenguin: 'Dublje u BotPenguin',
  knowWhereWeAreGoing: 'Znajte kamo idemo, najnovije informacije i pomozite nam ispraviti neke greške.',
  productUpdates: 'Ažuriranja proizvoda',
  requestAFeature: 'Zatraži značajku',
  reportABug: 'Prijavi grešku',
  productRoadmap: 'Product Roadmap',
  contactsOrLeads: 'Kontakti/Potencijalni kupci',
  english: 'Engleski',
  hindi: 'Hindi',
  german: 'Njemački',
  french: 'Francuski',
  portuguese: 'Portugalski',
  spanish: 'Španjolski',
  italian: 'Talijanski',
  russian: 'Ruski',
  pleaseSelectYourReason: 'Molimo odaberite svoj razlog',
  cancel: 'Odustani',
  submit: 'Pošalji!',
  giveFeedback: 'Dajte povratne informacije',
  ratings: 'Ocjene',
  reasonBehindYourDecision: 'Razlog vaše odluke',
  shareYourExperience: 'Podijelite svoje iskustvo',
  reason1: 'razlog1',
  reason2: 'razlog2',
  appTooltip: {
    HOME_INSIGHT: 'Pružite uvid u sve poruke i potencijalne kupce svih vaših botova (Podaci se ažuriraju svaki ponoć)',
    HOME_MESSAGES: 'Poruke koje je vaš račun potrošio tijekom ovog obračunskog ciklusa. (Poruke s WhatsAppa, Facebooka i Telegram Bota nisu uključene.)',
    HOME_TOTAL_MESSAGES: 'Ukupan broj poruka koje je vaš račun potrošio od trenutka stvaranja računa (Poruke s WhatsAppa, Facebooka i Telegram Bota nisu uključene.)',
    LEADS: 'Potencijalni kupci koje su botovi uhvatili za vaš račun tijekom ovog obračunskog ciklusa. ',
    TOTAL_LEADS: 'Ukupan broj kontakata/potencijalnih kupaca koje su botovi uhvatili za vaš račun od trenutka stvaranja računa (Podaci se ažuriraju svaki ponoć).',
    YOUR_BOT: 'Pregled svih vaših botova i njihova upotreba tijekom ovog obračunskog ciklusa.',
    NAME: 'Ime bota',
    PLATFORM: 'Platforma bota',
    MESSAGES: 'Ukupan broj poruka bota od trenutka stvaranja računa',
    CONTACTS: 'Ukupan broj kontakata/potencijalnih kupaca bota',
    ACTIONS: 'Uredi/Izbriši bota',
    EDIT_ICON: 'Uredi tok razgovora i postavke bota',
    DELETE_ICON: 'Izbriši bota',
    TOOL_TIP_CLASSIC_VERSION: `stara verzija ${brand} korisničkog sučelja`
  },
  modal: {
    deleteBot: 'Izbriši bota!',
    areYouSure: 'Jeste li sigurni da želite izbrisati ovog bota?',
    enquiryForm: 'Obrazac upita',
    payNow: 'Plati sada!',
    saveAndDelete: 'Spremi i izbriši',
    submit: 'Pošalji',
  },
  noDataFound: {
    bots: 'Botovi',
    noBotCreatedYet: 'Još nema stvorenih botova!',
  },
  yourFriendWillMissYou: 'Vaš prijatelj će vam nedostajati',
  rateYourBotCreationExperience: 'Ocijenite svoje iskustvo stvaranja bota',
  whatMadeYouDeleteYourBot: 'Što vas je natjeralo da izbrišete bota?',
  iCreatedByMistake: 'Stvorio sam ga greškom',
  iWantToCreateAnotherBot: 'Želim stvoriti drugog bota',
  couldNotFindFeaturesThatINeeded: 'Nisam mogao pronaći značajke koje mi trebaju',
  uiWasHardToNavigate: 'Korisničko sučelje je bilo teško za navigaciju',
  iDonotWantToTell: 'Ne želim reći',
  other: 'Drugo',
  weWillDoOurBestToMakeAutomationFun: 'Učinit ćemo sve kako bismo automatizaciju učinili zabavnom i jednostavnom za svakoga.',
};
